import { render, staticRenderFns } from "./juegoMillonario.vue?vue&type=template&id=4a7f3a3f&scoped=true"
import script from "./juegoMillonario.vue?vue&type=script&lang=js"
export * from "./juegoMillonario.vue?vue&type=script&lang=js"
import style0 from "./juegoMillonario.vue?vue&type=style&index=0&id=4a7f3a3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f3a3f",
  null
  
)

export default component.exports